<template>
  <div>
    <app-overlay-loader v-if="preloader" />
    <div class="content-wrapper" :class="{ 'loading-opacity': preloader }">
      <div class="row">
        <div class="col-sm-12 col-md-6">
          <app-breadcrumb
            :page-title="$t('Planificación')"
            :directory="$t('del equipo evaluador')"
            :icon="'trello'"
          />
        </div>
        <div class="col-sm-12 col-md-6">
          <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
            <button
              type="button"
              class="btn btn-primary btn-with-shadow"
              @click="returnPage()"
            >
              {{ $t("back") }}
            </button>
          </div>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-sm-6" :class="{ 'loading-opacity': preloader }">
          <div class="mt-2">
            <strong>
              Registro de Ingreso de solicitud de acreditación y Acuse Recibo
            </strong>
            <br />
            <a
              class="btn btn-success"
              :href="`${receipt_return_report}`"
              target="_blank"
            >
              <app-icon name="file" /> Ver</a
            >
          </div>
        </div>

        <div
          class="col-sm-6"
          :class="{ 'loading-opacity': preloader }"
          style="text-align: right"
        >
          <div class="mt-2" style="text-align: center">
            <strong>Solicitud de acreditación firmada</strong>
            <br />
            <a
              class="btn btn-success"
              :href="`${request_signed}`"
              target="_blank"
            >
              <app-icon name="file" /> Ver</a
            >
          </div>
        </div>
      </div>
      <hr />
      <div class="row" :class="{ 'loading-opacity': preloader }">
        <div class="col-sm-6">
          <strong> Código de la {{ type }} </strong>
          <br />
          <a
            :href="`/accreditations/applications/${accreditation_id}`"
            target="_blank"
            >{{ record }}</a
          >
        </div>
        <div class="col-sm-6">
          <!-- <strong> Evaluación In Situ </strong> -->
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12" v-if="file_evaluation_historical.length > 0">
          <div class="form-group">
            <legend>
              <label class="text-primary"
                >Historico de propuesta de equipo evaluador</label
              >
            </legend>
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th scope="col">Nombre del archivo</th>
                  <th scope="col">Usuario</th>
                  <th scope="col">Fecha</th>
                  <th scope="col" style="width: 10%; text-align: center">
                    Ver
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(value, file) in file_evaluation_historical"
                  :key="file"
                >
                  <td>Propuesta de equipo evaluador {{ file + 1 }}</td>
                  <td>{{ value.user.full_name }}</td>
                  <td>{{ dateToString(value.created_at) }}</td>
                  <td>
                    <a
                      class="btn btn-success"
                      :href="`${value.full_url}`"
                      target="_blank"
                    >
                      <app-icon name="file" /> Ver</a
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12" v-if="sampling_plan_file_historical.length > 0">
          <div class="form-group">
            <legend>
              <label class="text-primary">Historico del plan de muestreo</label>
            </legend>
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th scope="col">Nombre del archivo</th>
                  <th scope="col">Usuario</th>
                  <th scope="col">Fecha</th>
                  <th scope="col" style="width: 10%; text-align: center">
                    Ver
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(value, file) in sampling_plan_file_historical"
                  :key="file"
                >
                  <td>Plan de muestreo {{ file + 1 }}</td>
                  <td>{{ value.user.full_name }}</td>
                  <td>{{ dateToString(value.created_at) }}</td>
                  <td>
                    <a
                      class="btn btn-success"
                      :href="`${value.full_url}`"
                      target="_blank"
                    >
                      <app-icon name="file" /> Ver</a
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="row" v-if="proforms">
        <br /><br />
        <div class="col-12">
          <div class="mt-2">
            <strong>Rechazo de proforma</strong>
            <br />
            <a class="btn btn-danger" :href="`${proforms}`" target="_blank">
              <app-icon name="file" /> Ver</a
            >
          </div>
        </div>
      </div>
      <hr v-if="observations.length > 0" />
      <div class="row">
        <div class="col-12" v-if="observations.length > 0">
          <div class="form-group">
            <legend>
              <label class="text-primary">Observaciones</label>
            </legend>
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th scope="col">Observación</th>
                  <th scope="col">Fecha</th>
                  <th scope="col">Usuario</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(value, obs) in observations" :key="obs">
                  <td>{{ value.observation }}</td>
                  <td>{{ dateToString(value.created_at) }}</td>
                  <td>{{ value.user.full_name }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <hr />
      <div class="col-sm-12" style="text-align: center">
        <h3>{{ record }}</h3>
        <h2 class="text-primary" v-if="code">
          <b v-if="replanning" class="text-success">{{ replanning }}</b>
          <b v-if="!replanning">Planificación</b>
          del equipo evaluador para la {{ type }}
        </h2>
        <h3>{{ code }}</h3>
        <br /><br />
        <button
          class="btn btn-success btn-sm"
          @click="planningEvent"
          v-if="!information"
        >
          Planificar fecha de {{ type }}
        </button>
        <h2 v-if="!information" class="text-danger">
          Aun no se han registrado planificaciones para esta {{ type }}
        </h2>
        <button
          class="btn btn-success btn-sm"
          v-if="information"
          @click="planningEvent"
        >
          Ver planificación
        </button>
        <br />
        <br />
      </div>

      <div
        class="row"
        v-if="information"
        :class="{ 'loading-opacity': preloader }"
      >
        <div class="col-12">
          <legend>
            <p class="text-primary">Datos de la {{ type }}</p>
          </legend>
        </div>
        <hr />
        <app-overlay-loader v-if="preloader" />
        <div class="col-sm-4">
          <strong>Codigo de la {{ type }}</strong>
        </div>
        <div class="col-sm-4">
          <strong>Fecha y hora de inicio</strong>
        </div>
        <div class="col-sm-4"><strong>Fecha y hora de fin</strong></div>
        <div class="col-sm-4">{{ code }}</div>
        <div class="col-sm-4">
          {{ desde }}
        </div>
        <div class="col-sm-4">{{ hasta }}</div>
        <hr />
        <br />
        <hr />

        <div class="col-sm-12 mt-3" v-if="information && showQuestionDoc">
          <legend>
            <p class="text-primary">
              ¿Necesita realizar evaluación documental?
            </p>
          </legend>
          <app-input
              id="inputs_approved"
              class="col-sm-12"
              type="radio-buttons"
              :list="listOptionsSystem"
              @input="clicked"
              v-model="vigilance_documentary_evaluation"
              :required="true"
          />
        </div>

        <div class="col-sm-12" v-if="information">
          <br />
          <br />
          <legend>
            <p class="text-primary">Equipo</p>
          </legend>
        </div>
        <div class="col-sm-12" v-if="information">
          <table class="table">
            <thead>
              <tr>
                <th scope="col">Tipo</th>
                <th scope="col">Nombre</th>
                <th scope="col">Institución</th>
                <th scope="col">Estado</th>
                <!-- <th scope="col">Fecha de participación</th>
                <th scope="col" style="width: 5%">Planificar</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(value, index) in evaluators" :key="index">
                <td>{{ value.evaluator_type.value }}</td>
                <td>
                  {{ capitalizeFirstLetters(value.evaluator.first_name) }}
                  {{ capitalizeFirstLetters(value.evaluator.last_name) }}
                </td>
                <td>{{ value.evaluator.institution }}</td>
                <td>
                  <span class="badge badge-sm badge-pill badge-warning">
                    Pendiente de aceptación
                  </span>
                </td>
              </tr>
              <tr v-if="observer">
                <td>Observador(es)</td>
                <td>{{ observer }}</td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>

        <br />
        <hr />

        <div
          class="col-12"
          v-if="type == 'testificación' && evaluators.length > 0"
        >
          <legend>
            <p class="text-primary">
              Seleccionar el evaluador responsable del proceso
            </p>
          </legend>
        </div>
        <div
          class="col-12"
          v-if="type == 'testificación' && evaluators.length > 0"
        >
          <div class="form-group">
            <label class="mb-0">Seleccionar evaluador</label>
            <app-input
              type="select"
              v-model="reviewer_id"
              :list="evaluatorSignedList"
              required
            />
          </div>
        </div>
        <br />
        <hr />
        <!-- <div class="col-12">
          <br />
          <legend>
            <p v-if="insitu_remote == 0" class="text-primary">In situ</p>
            <p v-if="insitu_remote == 1" class="text-primary">Remota</p>
          </legend>
          <p v-if="insitu_remote == 0"><span v-html="insituText"></span></p>
          <p v-if="insitu_remote == 1"><span v-html="remoteText"></span></p>
        </div> -->
      </div>
      <br />
      <hr />

      <div v-if="information">
        <form ref="form" data-url="/accreditationtechnical/planningteam/update">
          <!-- <div class="form-group" style="text-align: center">
            <img src="/storage/pdf.png" alt="" width="100" />
          </div> -->

          <!-- <div class="form-group">
            <label
              ><strong>{{
                $t("Propuesta de designación de equipo evaluador") 
              }} <b class="text-danger">*</b></strong></label
            >
            <app-input
              :class="{ 'loading-opacity': preloader }"
              type="file"
              accept=".pdf"
              :label="inputs.file ? inputs.file.name : $t('upload_your_file')"
              v-model="inputs.file"
              :required="true"
            />
          </div>

          <div class="form-group" v-if="is_laboratory">
            <label><b>Plan de muestreo </b><b class="text-danger">*</b></label>
            <app-input
              type="file"
              :label="
                inputs.file_1 ? inputs.file_1.name : $t('upload_your_file')
              "
              v-model="inputs.file_1"
              :required="true"
              v-if="!inputs.sampling_plan_file"
            />
          </div> -->

             <div class="row" style="width: 100%">
              <div class="col-sm-12" style="text-align: center">
                <br />
                <button
                  :class="{ 'loading-opacity': preloader }"
                  type="submit"
                  class="btn btn-primary mr-2"
                  @click.prevent="submit"
                >
                  Continuar
                </button>
              </div>
            </div>
        </form>
      </div>
      <planification-modal
        v-if="isAddEditModalActive"
        :selected-url="selectedUrl"
        :evaluation="evaluation"
        :evaluatorData="evaluatorData"
        title="Crear planificación para este miembro"
        @close-modal="closeAddEditModal"
      />
    </div>
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "../../../apiUrl";
import { TableHelpers } from "./TableHelpers";
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
export default {
  extends: CoreLibrary,
  name: "RegisterStages",
  mixins: [FormMixin, TableHelpers],

  props: {
    evaluationId: String,
  },
  data() {
    return {
      preloader: false,
      type: "",
      showList: [
        {
          id: 0,
          value: "NO",
        },
        {
          id: 1,
          value: "SI",
        },
      ],
      evaluationsList: [],
      show_select: 0,
      show: [],
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      observations_evaluation_team_302: "",
      observations_evaluation_team_305: "",
      TestificationList: [],
      evaluations: [],
      inputs: [],
      city: "",
      number_testifications: 1,
      number_concat: 0,
      planningEvaluation: [],
      rule_name: "",
      lider: "",
      number_days: "",
      evaluators: "",
      application_name: "",
      team: "",
      code: "",
      desde: "",
      hasta: "",
      accreditation_id: "",
      information: "",
      record: "",
      observer: "",
      proforms: "",
      observations: "",
      replanning: "",
      request_signed: "",
      is_documentary: 0,
      receipt_return_report: "",
      evaluatorSignedList: "",
      isAddEditModalActive: "",
      typeList: [
        {
          id: 0,
          value: "In Situ",
        },
        {
          id: 1,
          value: "Remota",
        },
      ],

      typeTestificationList: [
        {
          id: 0,
          value: "Presencial",
        },
        {
          id: 1,
          value: "Remota",
        },
      ],

      documentalList: [
        {
          id: 0,
          value: "NO",
        },
        {
          id: 1,
          value: "SI",
        },
      ],
      showQuestionDoc: false,
      vigilance_documentary_evaluation: 0,
      listOptionsSystem: [
        {
          id: "0",
          value: "No",
        },
        {
          id: "1",
          value: "Si",
        },
      ],
      insitu_remote: "",
      insituText: "",
      remoteText: "",
      file_evaluation_historical: [],
      sampling_plan_file_historical: [],
      tableId: "evaluation-list",
      evaluatorData: "",
      reviewer_id : "",
      evaluation: "",
      is_laboratory: false,
      rowData: {},
      options: {
        url: `${actions.PLANNING_TEAM}/planningEvaluation/${this.evaluationId}`,
        name: this.$t("demo_crud"),
        showHeader: true,
        columns: [],
        showFilter: false,
        showSearch: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
    };
  },
  created() {
    this.options.columns = [...this.tableColumns];
    this.evaluationData();
    this.evaluationPlanning();
    this.evaluationObservations();
    this.table();
  },
  methods: {
    table() {
      let url = `/accreditationtechnical/planningteam/planningEvaluation/${this.evaluationId}`;
      this.axiosGet(url).then((response) => {
        this.lider = response.data.lider;
        this.evaluators = response.data.evaluadores;
      });
    },
    capitalizeFirstLetters(str) {
      return str.toLowerCase().replace(/^\w|\s\w/g, function (letter) {
        return letter.toUpperCase();
      });
    },
    openAddEditModal(evaluator) {
      this.evaluatorData = evaluator;
      this.isAddEditModalActive = true;
    },

    closeAddEditModal() {
      $("#planification-add-edit-modal").modal("hide");
      this.isAddEditModalActive = false;
      this.table();
    },

    dateToString(date) {
      return date != null ? moment(date).format("YYYY-MM-DD HH:mm") : null;
    },
    returnPage() {
      window.location.href = "/accreditationtechnical/accreditationsteam";
    },
    evaluationObservations() {
      let url = `${actions.PLANNING_TEAM}/observationList/${this.evaluationId}`;
      this.axiosGet(url).then((response) => {
        this.observations = response.data;
      });
    },
    evaluationData() {
      this.preloader = true;
      let url = `${actions.PLANNING_TEAM}/planningData/${this.evaluationId}`;
      this.axiosGet(url).then((response) => {
        this.evaluation = response.data.evalTest;
        this.evaluationsList = response.data.evalTestList;

        var laboratory =
          response.data.evalTest.accreditation_applications.accreditation_area
            .name;
        if (laboratory == "LABORATORIOS") {
          this.is_laboratory = true;
        }
        this.vigilance_documentary_evaluation = response.data.evalTest.vigilance_documentary_evaluation;
        this.code = response.data.evalTest.code;
        this.accreditation_id = response.data.evalTest.accreditation_id;
        this.desde =
          response.data.evalTest.date_start +
          " | " +
          this.timeTo24(response.data.evalTest.time_start);
        this.hasta =
          response.data.evalTest.date_end +
          " | " +
          this.timeTo24(response.data.evalTest.time_end);
        this.record = response.data.evalTest.accreditation_applications.record;
        this.insitu_remote = response.data.evalTest.insitu_remote;
        this.insituText = response.data.insitu.name;
        this.remoteText = response.data.remote.name;
        this.observer = response.data.evalTest.eval_observer;
        this.request_signed =
          response.data.evalTest.accreditation_applications.request_signed.full_url;
        this.receipt_return_report =
          response.data.evalTest.accreditation_applications.receipt_return_report.full_url;

        var fecha1 = moment(response.data.evalTest.date_start);
        var fecha2 = moment(response.data.evalTest.date_end);

        this.number_days = fecha2.diff(fecha1, "days") + 1;

        if (response.data.evalTest.reviewer_id) {
          this.reviewer_id = response.data.evalTest.reviewer_id;
        }

        if (response.data.evalTest.type == "E") {
          this.type = "evaluación";
        } else {
          this.type = "testificación";
        }
        if (response.data.evalTest.replanning_counter > 0) {
          this.replanning = "Replanificación";
        }
        if (response.data.evalTest.proforms.length > 0) {
          var position = response.data.evalTest.proforms.length - 1;
          this.proforms = response.data.evalTest.proforms[position].full_url;
        }

        if (response.data.evalTest.file_evaluation_historical301.length > 0) {
          this.file_evaluation_historical =
            response.data.evalTest.file_evaluation_historical301;
        }

        if (response.data.evalTest.sampling_plan_file_historical.length > 0) {
          this.sampling_plan_file_historical =
            response.data.evalTest.sampling_plan_file_historical;
        }

        const typeAcc =
            response.data.evalTest.accreditation_applications.accreditation_type
                .name;

        if (typeAcc === "Ampliación" && response.data.evalTest.type === "E") {
          this.showQuestionDoc = true;
        }
        this.preloader = false;
      });
    },

    getListAction(rowData) {
      this.rowData = rowData;
    },

    beforeSubmit() {
      this.preloader = true;
    },
    submit() {
      // if (!this.inputs.file) {
      //   this.$toastr.e(this.$t("Es necesario subir un archivo"));
      // } else {
      // var fileName = this.inputs.file.name;
      // var extension = fileName.substr(-4);
      // if (extension == ".pdf") {
      let formData = new FormData();

      formData.append("file", this.inputs.file);
      formData.append("file_1", this.inputs.file_1);
      formData.append("eval_test_id", this.evaluationId);
      formData.append("accreditation_application_id", this.accreditation_id);
      formData.append("insitu_remote", this.insitu_remote);
      formData.append("city", this.city);
      formData.append("reviewer_id", this.reviewer_id);
      formData.append("documentary_evaluation", this.is_documentary);
      formData.append("arrayEvalTest", this.show);
      this.save(formData);
      // } else {
      //   this.$toastr.e(
      //     this.$t("Ingresar un archivo válido, solo se aceptan PDF")
      //   );
      // }
      // }
    },

    afterSuccess() {
      this.preloader = false;
      this.$toastr.s(this.$t("created_success"));
      window.location = "/accreditationtechnical/accreditationsteam";
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.preloader = false;
      this.$toastr.e(res.data.message);
    },

    evaluationPlanning() {
      this.preloader = true;
      let url = `${actions.PLANNING_TEAM}/planningEvaluation/${this.evaluationId}`;
      this.axiosGet(url).then((response) => {
        this.planningEvaluation = response.data;
        this.evaluatorSignedList = [
          { id: "", value: this.$t("select_option") },
          ...response.data.evaluatorSign,
        ];
        this.preloader = false;
        // this.information = true;
        if (response.data.evaluadores.length > 0) {
          this.information = true;
        }
      });
    },

    planningEvent() {
      window.location = `${actions.PLANNING_TEAM}/planningEvents/${this.evaluationId}`;
    },

    timeTo24(time) {
      return time != null ? moment(time, ["h:mm A"]).format("HH:mm") : null;
    },
    clicked(){
      const url = `/accreditationtechnical/signatureDocument/signatureDocumentReport/process/updateDoc/${this.evaluationId}/${this.vigilance_documentary_evaluation}`;
      this.axiosGet(url)
          .then((res) => {})
          .catch(({ error }) => {
            console.log(error);
          });
    }
  },
};
</script>